import RenderManager from "../rendering/render-manager";
import Utils from "../utils";
import * as Events from "../utils/events";
import EntranceExit from "./EntranceExit";
import Base2DElement from "./base-2d-element";

class Iframe extends Base2DElement {
    get type2d() { return "Iframe"; }

    _initDefaultVars() {
        super._initDefaultVars();
        this._wh = new THREE.Vector2(0.4, 0.35);
        this._src = "";
    }

    get src() { return this._src; }
    set src(val) { this._src = val; }

    _initValues(options) {
        this._src = "src" in options ? options.src : this._src;
    }

    _createContainer() {
        const container = super._createContainer();

        container.style.position = "absolute";

        return container;
    }

    constructor(options, parentLayer, uuid) {

        super(options, parentLayer, uuid);

        this.iframeWrap = document.createElement("div");
        this.iframeElement = document.createElement("div");
        this.iframeWrap.classList.add('iframe-wrap');
        this.iframeWrap.appendChild(this.iframeElement);
        this.iframeElement.classList.add('iframe-element');

        if (Q3.editMode) { this.iframeElement.classList.add('editor-mode'); }

        this.domElement.appendChild(this.iframeWrap);
        this.parentLayer.subtype = "iframes";

        this.boxElement = document.createElement("div");
        this.boxElement.classList.add('iframe-box');
        this.iframe = document.createElement("iframe");

        this.iframeElement.appendChild(this.boxElement);
        this.iframeElement.appendChild(this.iframe);
        this.iframeElement.style.pointerEvents = (!Q3.editMode && this.disableEvents) ? "none" : "auto";

        if (Q3.isReady) {
            this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
            this.enterExitCtrl.init(options);
        } else {
            Q3.Events.listen("tourReady", () => {
                this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
                this.enterExitCtrl.init(options);
            })
        }


        if (Q3.editMode) {
            this.domElement.addEventListener('click', e => {
                this.selectHandler(e);
            }, false);
        }

        const { width, height } = RenderManager.getSize();

        this.redraw = this.redraw.bind(this);

        this.handleListeners(true);

        this.redraw(width, height);

        if (!options.new) {
            this.setIframeText(this.src);
        }
    }

    handleListeners(add) {
        Events[add ? "listen" : "unlisten"]("viewportchanged", this.redraw);
        Events[add ? "listen" : "unlisten"]("splashremoved", this.redraw);
    }

    playLeavingAnimation() {
        this.enterExitCtrl.playLeave();
    }

    cancelLeavingAnimation() {
        this.enterExitCtrl.cancelLeave();
    }

    calcSize(w, h) {
        if (h > w * 0.5625) {
            return {
                width: w + "px",
                height: w * 0.5625 + "px"
            }
        } else {
            return {
                width: h / 0.5625 + "px",
                height: h + "px"
            }
        }
    }

    setIframeText(value) {
        value = value.trim();
        if (value.indexOf("<iframe") !== 0) {
            if (value.indexOf("http://") !== 0 && value.indexOf("https://") !== 0) {
                value = "https://" + value;
            }
            value = `<iframe src="${value}"></iframe>`
        }
        this.src = value;
        Events.fire('selectchange');
        this.iframeElement.innerHTML = "";
        this.iframe = document.createElement("iframe");
        this.iframeElement.appendChild(this.boxElement);
        this.iframeElement.appendChild(this.iframe);
        value = value.replace(/allowfullscreen/g, "");
        this.iframe.outerHTML = value;
        return value;
    }

    render(width, height) {
        if (!Q3.data.layers.layers2D[this.parentLayer.uuid] || this.disabled || Utils.queryParams.has("disable_2d")) return;

        if (!this.isMounted || this.target) {
            this.redraw(width, height);
            if (width > 0 && height > 0) {
                this.isMounted = true;
            }
        }
    }

    redraw(width, height) {

        !width && (width = RenderManager.domElement.width / RenderManager.pixelRatio);
        !height && (height = (RenderManager.domElement.height) / RenderManager.pixelRatio);

        let currentSize = this.getVWSize();
        if (this[currentSize]) {
            Object.assign(this, this[currentSize]);
        }
        if (!Q3.editMode && this.inLetterbox !== false) {
            width = Q3.letterbox.offsetWidth / RenderManager.pixelRatio;
            height = (Q3.letterbox.offsetHeight) / RenderManager.pixelRatio;
        }

        if (Q3.editMode) {
            if (Q3.mobileView && this.hiddenMobile) {
                this.domElement.style.opacity = 0.4;
            } else if (!Q3.mobileView && this.hiddenDesktop) {
                this.domElement.style.opacity = 0.4;
            } else {
                this.domElement.style.opacity = 1;
            }
        }

        let w = this.width * width * RenderManager.pixelRatio;
        let h = this.height * height * RenderManager.pixelRatio;

        Object.assign(this.iframeWrap.style, {
            width: w + 'px',
            height: h + 'px'
        });

        let size = this.calcSize(w, h);
        this.inLetterbox === false && (size = { width: w + 'px', height: h + 'px' });
        Object.assign(this.iframeElement.style, size);

        var x, y;

        [x, y] = this._calcPosition(width, height);

        Object.assign(this.domElement.style, {
            width: w + 'px',
            height: h + 'px',
            top: y + "px",
            left: x + "px"
        });

    }

    delete() {

        this.handleListeners(false);

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);
        this.parentLayer.domElement.removeChild(this.domElement);

        delete this.domElement;

        if (Q3.selected === this) {
            Q3.selected = null;
            Events.fire('selectchange');
        }

    }

    clone() {

        // const picture = new Picture({
        //   src: this.src,
        //   x: this.x + 0.01,
        //   y: this.y + 0.01,
        //   targetUuid: this.targetUuid
        // },
        //   this.parentLayer,
        //   THREE.Math.generateUUID()
        // );
        //
        // Q3.data.layers.layers2D[ picture.parentLayer.uuid ].objects[ picture.uuid ] = {
        //   type: 'picture',
        //   src: picture.filename,
        //   x: picture.x,
        //   y: picture.y,
        //   targetUuid: picture.targetUuid
        // };
        //
        // this.parentLayer.objects.splice( this.index, 0, text );
        // this.parentLayer.objects.forEach( ( o, i ) => o.index = i );
        //
        // return picture;

    }

    hide() {

        this.pictureElement.classList.add('q3-picture-occluded');

    }

    show() {

        this.pictureElement.classList.remove('q3-picture-occluded');

    }

    setData(data) {

        let currentSize = this.getVWSize();
        Object.assign(this[currentSize], {
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height
        });

        this.data[currentSize] = {};

        Object.assign(this.data[currentSize], {
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height
        });

        this.redraw();

    }


}

export default Iframe;
export { Iframe };
